export const CMS_CONTENT_IDS = {
  NEW_MAP_BANNER: 'c81da057-8279-4e05-b966-4fd8cc16842d',
  NEW_MAP_MODAL: '24812d41-5275-4265-9228-cb0f349cb65e',
} as const;
